import { WagtailMenuPage, WagtailPage, WagtailPageMeta } from '@lacerta/wagtail';
import { LacertaWagtailPage } from '../page.model';

export const convertPagesToMenu = (pages: LacertaWagtailPage[], id: number): WagtailMenuPage[] =>
  pages.filter((item) => item.meta.parent?.id === id).map((page) => ({ page, children: convertPagesToMenu(pages, page?.id) }));

export const buildDummyMenuPage = (title: string, slug: string): WagtailMenuPage => ({
  page: { title, meta: { slug } as WagtailPageMeta } as WagtailPage,
});
